import Vue from 'vue'
import axios from 'axios'
// import store from '@/store'
// import { VueAxios } from './axios'
import {Modal, notice} from 'view-design'
import router from '../router';
import store from '../store'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
// let apiBaseUrl = window._CONFIG['domianURL'] || "/jcpt";
let apiBaseUrl = "/jcpt";
// 创建 axios 实例
const service = axios.create({
  //baseURL: '/jeecg-boot',
  baseURL: apiBaseUrl, // api base_url
  timeout: 9000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = localStorage.getItem('Access-Token')
    console.log("------异常响应------",token)
    console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        notice.error({ title: '系统提示', desc: '拒绝访问',duration: 4})
        break
      case 500:
        //notice.error({ title: '系统提示', desc:'Token失效，请重新登录!',duration: 4})
        if(token && data.message=="Token失效，请重新登录"){
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                sessionStorage.setItem('redirect', router.currentRoute.fullPath)
                router.push('/login')
              })
            }
          })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // Token失效时返回一个特殊的rejected promise，不再继续传播错误
          return Promise.reject({ isTokenExpired: true })
        }
        break
      case 404:
          notice.error({ title: '系统提示', desc:'很抱歉，资源未找到!',duration: 4})
        break
      case 504:
        notice.error({ title: '系统提示', desc: '网络超时'})
        break
      case 401:
        notice.error({ title: '系统提示', desc:'未授权，请重新登录',duration: 4})
        if (token) {
          // store.dispatch('Logout').then(() => {
          //   setTimeout(() => {
          //     window.location.reload()
          //   }, 1500)
          // })
        }
        break
      default:
        notice.error({
          title: '系统提示',
          desc: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = localStorage.getItem('Access-Token')

  if (token) {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if(config.method=='get'){
    if(config.url.indexOf("sys/dict/getDictItems")<0){
      config.params = {
        _t: Date.parse(new Date())/1000,
        ...config.params
      }
    }
  }
  return config
},(error) => {
  console.log(error)
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
  }, err)

// const installer = {
//   vm: {},
//   install (Vue, router = {}) {
//     Vue.use(VueAxios, router, service)
//   }
// }

export {
  // installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js